let currentURL;
const variantSelector = document.querySelector('.variant-option--buttons');
const nav = document.querySelector('header-menu');
const mobileNav = document.querySelector('.menu-drawer__navigation');
const accountNav = document.querySelector('.account-actions__nav');
const linkDYR = document.querySelector('.design-rug');
const mediaGallery = document.querySelector('.rio-media-gallery');
const updateMessage = document.querySelector('.update-message');
const variantPattern = document.getElementById('variant-pattern');
const variantPatternRepeat = document.getElementById('variant-pattern-repeat');
const variantBacking = document.getElementById('variant-backing');
const variantConstruction = document.getElementById('variant-construction');
const variantComposition = document.getElementById('variant-composition');
const variantWidth = document.getElementById('variant-width');
const variantRepeatBlurb = document.getElementById('variant-repeat-blurb');
const productTabNav = document.querySelector('.main-product-tab__nav');
const outletTabContent = document.querySelector('.outlet-tab__content');
const outletMobileNavs = document.querySelectorAll('.outlet-tab__mobile-nav-container');
const inventoryQty = document.getElementById('variant-quantity');

localStorage.removeItem('selectedVariant');

const outletTabSwitch = function(str) {
  document.querySelectorAll('.outlet-tab__content-item').forEach(el => el.classList.remove('outlet-tab__content-item--active'))
  outletTabContent.querySelector(`.${str}`).closest('.outlet-tab__content-item').classList.add('outlet-tab__content-item--active')
}

const outletTabSwitchMobile = function(str) {
  outletTabContent.querySelector(`.${str}`).closest('.outlet-tab__content-item').classList.toggle('outlet-tab__content-item--mobile-active')
}

const getInventoryQty = async function(itemNumber) {
  if (!itemNumber) {
    inventoryQty.classList.remove("green", "orange");
    return inventoryQty.textContent = "Data Not Available"
  }
  try {
    const url = `https://fibreworks-customer-app.azurewebsites.net/api/v1/sql/item-qty?itemNumber=${itemNumber}`;
    const data = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-type': 'application/json'
          }
        }).then((res) => res.json()).then(res => {
          if (res.status === 'success') {
            return res;
          } else {
            console.log(res.message)
          }
        });
    if (!data.data?.ITEMNMBR ?? null) return inventoryQty.textContent = "Data Not Available";
    const goodLotAvail = data.lotData.some(lot => lot.SUMQTYRECVD - lot.SUMQTYSOLD - lot.SUMATYALLOC > 50);
    const goodLots = data.lotData.filter(lot => lot.SUMQTYRECVD - lot.SUMQTYSOLD - lot.SUMATYALLOC > 25);
    const totalOfGoodLots = goodLots.map(lot => lot.SUMQTYRECVD - lot.SUMQTYSOLD - lot.SUMATYALLOC).reduce((acc, lotQty) => acc + lotQty, 0) - data.data.ATYALLOC;
    // const totalAvail = data.data.QTYONHND - data.data.ATYALLOC;
    if (inventoryQty && totalOfGoodLots > 50) {
      inventoryQty.classList.add("green");
      inventoryQty.classList.remove("orange");
      inventoryQty.textContent = totalOfGoodLots > 120 ? "Available" : "Limited Availability"
    } else {
      inventoryQty.classList.remove("green");
      inventoryQty.classList.add("orange");
      inventoryQty.textContent = `Contact Account Manager for Availability`
    }
  } catch (err) {
    console.error(err)
    inventoryQty.textContent = "Data updating...";
    setTimeout(() => {
      getInventoryQty(itemNumber)
    }, 10000);
  }
}

const setStorage = function() {
  localStorage.setItem('selectedVariant', JSON.stringify({product: thisProduct.camel, variant: thisProduct.variants[selectedVariantID].title, productID: thisProduct.id, variantID: thisProduct.variants[selectedVariantID].id, excludeSerging: thisProduct.variants[selectedVariantID].excludeSerging, rugPadOptions: thisProduct.variants[selectedVariantID].rugPadOptions}))
}

const removeStorage = function(e) {
  if (!e.target.href === '/pages/design-your-rug') return;
  localStorage.removeItem('selectedVariant');
}

// const saveRugField = function() {
//   const productID = thisProduct.id;
//   const variantID = thisProduct.variants[selectedVariantID].id;
//   const newRugField = {product: thisProduct.id, variant: Number(selectedVariantID)};
//   if (savedRugFields.some(obj => obj.variant === newRugField.variant)) {
//   } else {
//     savedRugFields.push(newRugField);
//   }
//   ravenSubmit(JSON.stringify(savedRugFields));
// }

// const saveBorder = function() {
//   const productID = thisProduct.id;
//   const variantID = thisProduct.variants[selectedVariantID].id;
//   const newBorder = {product: productID, variant: variantID};
//   if (savedBorders.some(obj => obj === newBorder)) {
//   } else {
//     savedBorders.push(newBorder);
//   }
//   ravenSubmitBorder(JSON.stringify(savedBorders));
// }

// const saveWallcovering = function() {
//   const productID = thisProduct.id;
//   const variantID = thisProduct.variants[selectedVariantID].id;
//   const newWallcovering = {product: productID, variant: variantID};
//   if (savedWallcoverings.some(obj => obj === newWallcovering)) {
//   } else {
//     savedWallcoverings.push(newWallcovering);
//   }
//   ravenSubmitWallcovering(JSON.stringify(savedWallcoverings));
// }

const updateVariant = function(id=selectedVariantID) {
  selectedVariantID = id;
  variantPattern.textContent = thisProduct.variants[selectedVariantID].pattern.join(', ');
  if (variantPatternRepeat) variantPatternRepeat.textContent = thisProduct.variants[selectedVariantID].patternRepeat || "N/A";
  variantRepeatBlurb.textContent = thisProduct.variants[selectedVariantID].repeatAsteriskBlurb ? `* ${thisProduct.variants[selectedVariantID].repeatAsteriskBlurb}` : null;
  variantBacking.textContent = thisProduct.variants[selectedVariantID].backing;
  variantConstruction.textContent = thisProduct.variants[selectedVariantID].construction;
  variantComposition.textContent = thisProduct.variants[selectedVariantID].fiberComposition;
  variantWidth.textContent = thisProduct.variants[selectedVariantID].width;
  // setStorage();
  if (inventoryQty) inventoryQty.classList.remove("green", "orange");
  if (inventoryQty) inventoryQty.textContent = 'Loading...';
  if (inventoryQty) getInventoryQty(thisProduct.variants[selectedVariantID].itemNumber ?? null);
}

if (productTabNav) {
  productTabNav.addEventListener('click', function(e) {
    const selection = e.target.closest('.outlet-tab__list-item');
    if (!selection) return;
    document.querySelectorAll('.outlet-tab__list-item').forEach(el => el.classList.remove('active'));
    selection.classList.add('active');
    const section = selection.getAttribute('data-content-ref');
    outletTabSwitch(section);
  });
}

outletMobileNavs.forEach(el => {
  el.addEventListener('click', function(e) {
    const selection = e.target.closest('.outlet-tab__mobile-nav-container');
    if (!selection) return;
    selection.classList.toggle('active');
    const section = selection.getAttribute('data-content-ref');
    outletTabSwitchMobile(section);
  })
})

variantSelector.addEventListener('click', function(e) {
    const clicked = e.target.closest('input');
    if (!clicked) return;
    const selectedID = clicked.dataset['variantId'];
    updateVariant(selectedID);
})

nav.addEventListener('click', removeStorage);
mobileNav.addEventListener('click', removeStorage);
accountNav.addEventListener('click', removeStorage);
if (linkDYR) linkDYR.addEventListener('click', setStorage);
updateVariant();
